const ConfirmationList = ({ children }) => (
  <div className="confirmation__list">
    { children }
  </div>
);

export default ConfirmationList;
